import Box from '@zenbusiness/zui/Box';
import DialogActions from '@zenbusiness/zui/DialogActions';
import { styled } from '@zenbusiness/zui/styles';

export const DialogActionsStyled = styled(DialogActions, {
  shouldForwardProp: (prop) => prop !== 'bgColor'
})(() => ({
  padding: '16px 0px',
  width: '100%',
  bottom: 'env(safe-area-inset-bottom, 0px)' /* Avoid overlapping with safe area inset on iOS */,
  right: 0,
  position: 'fixed!important',
  backgroundColor: 'rgba(240, 240, 240, 0.5)',
  backdropFilter: 'blur(12px)'
}));

export const ContainerGridStyled = styled(Box)(() => ({
  width: '100%',
  padding: '0 5%',
  '@media (min-width: 1536px)': {
    padding: 0,
    margin: '0 auto',
    maxWidth: '1440px'
  }
}));

export const InfoContainerGridStyled = styled(Box)(() => ({
  width: '100%',
  padding: '0 16px'
}));

export const FirstButtonWrapper = styled(Box)(({ theme }) => ({
  gridColumn: '1 / span 4',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 4'
  },
  [theme.breakpoints.up('md')]: {
    width: 'auto',
    gridColumn: '11 / 12'
  }
}));

export const SecondButtonWrapper = styled(Box)(({ theme }) => ({
  gridColumn: '1 / span 4',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '4 / 7'
  },
  [theme.breakpoints.up('md')]: {
    width: 'auto',
    gridColumn: '12 / 13'
  }
}));

export const ButtonContentItemPrimary = styled(Box)(({ theme }) => ({
  gridColumn: '1 / span 4',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    width: 'auto',
    gridColumn: '4 / 10',
    justifySelf: 'end'
  }
}));

export const ButtonContentItemSecondary = styled(Box)(({ theme }) => ({
  gridColumn: '1 / span 4',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    width: 'auto',
    gridColumn: '1 / 6',
    justifySelf: 'end'
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: '1 / 13'
  },

  [theme.breakpoints.up('lg')]: {
    gridColumn: '1 / 12'
  }
}));

export const ButtonContentItemTertiary = styled(Box)(({ theme }) => ({
  gridColumn: '1 / span 4',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    width: 'auto',
    gridColumn: '3 / 11',
    justifySelf: 'end'
  }
}));

export const ButtonContentItemFullWidth = styled(Box)(({ theme }) => ({
  gridColumn: '1 / span 4',
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    gridColumn: '1 / 7'
  },
  [theme.breakpoints.up('md')]: {
    width: 'auto',
    gridColumn: '1 / 13',
    justifySelf: 'end'
  }
}));
